import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { VehicleSetup } from 'contracts/VehicleSetups';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_VEHICLE_SETUP_',
  }
);

export interface FetchVehicleSetupState {
  data: VehicleSetup | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchVehicleSetupRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: VehicleSetup;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchVehicleSetupState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchVehicleSetupState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchVehicleSetupState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchVehicleSetupState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchVehicleSetupState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchVehicleSetup = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchVehicleSetupTypes = Types;
export const FetchVehicleSetupActions = Creators;
